<template>
  <aside ref="sidebar" class="mc-delivery-track-sidebar">
    <div ref="sidebarWrapper" class="mc-delivery-track-sidebar-wrapper">
      <span ref="sidebarToggle" class="mc-delivery-track-sidebar-toggle" @click="clickToggle()">
        <i class="mc-fa icon-fill_arrow-ios-left"></i>
        <i class="mc-fa icon-fill_arrow-ios-right"></i>
      </span>
      <div
        class="mc-delivery-track-sidebar-header d-flex align-items-center justify-content-between"
      >
        <h4 ref="sidebarHeader">
          {{ selectedMarker?.title }}
        </h4>
        <span class="popup-close" @click="closeSection()">
          <i class="mc-fa icon-fill_close"></i>
        </span>
      </div>
      <div
        ref="sidebarBody"
        class="mc-delivery-track-sidebar-body mc-delivery-track-mobile-info-grid"
      >
        <template v-for="(field, idx) in selectedMarker.fields">
          <div
            v-if="!field.divider && field.isShow !== false"
            :key="'field-' + idx"
            :class="['mc-delivery-track-mobile-info-field', { 'is-half': field.column === 'half' }]"
          >
            <p class="mc-delivery-track-mobile-info-label">
              {{ field.label }}
            </p>
            <p v-if="field.showValue !== false" class="mc-delivery-track-mobile-info-value">
              <strong>{{ field.value }}</strong>
            </p>
          </div>
          <hr
            v-else-if="field.divider && field.isShow !== false"
            :key="'divider-' + idx"
            class="mc-delivery-track-mobile-info-divider"
          />
        </template>
      </div>
    </div>
    <footer ref="sidebarFooter" class="mc-delivery-track-sidebar-footer">
      <span>
        {{ 'Terakhir diupdate pada :' }}
        {{ formatIndexDate(currentDateTime).date + ', ' + formatIndexDate(currentDateTime).time }}
      </span>
      <div>
        <span
          :hidden="
            getAsset('copyrightLogo', 'general') == null ||
            getAsset('copyrightLogo', 'general') == ''
          "
          >{{ $t('global.text.poweredBy') }} :
        </span>
        <figure class="d-inline-block mb-0">
          <img
            ref="imgCopyrightLogo"
            alt
            :src="getAsset('copyrightLogo', 'general')"
            @load="handleImageLoad()"
          />
        </figure>
      </div>
    </footer>
  </aside>
</template>
<script>
import { mapGetters } from 'vuex'
import { formatIndexDate } from '@/helpers/tzDate'
import debounce from 'lodash'

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    currentDateTime: {
      type: String,
      default: null,
    },
    selectedMarker: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      sidebarHeight: 0,
      resizeListener: null,
      isImageLoading: false,
      lastPosition: null,
      isLoadingLastPosition: true,
      markers: {},
    }
  },
  computed: {
    ...mapGetters({
      getAsset: 'asset/getAsset',
    }),
  },
  mounted() {
    this.resizeListener = () => debounce(this.calculateCompHeight(true), 150)
    window.addEventListener('resize', this.resizeListener)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeListener)
  },
  methods: {
    formatIndexDate,
    clickToggle() {
      const sidebar = this.$refs.sidebarBody
      const isFullMap = document.body.classList.contains('mc-full-map')
      document.body.classList.toggle('mc-full-map')

      if (window.innerWidth >= 890) {
        if (isFullMap) {
          const controlLeft = document.getElementsByClassName('control-left')
          Array.from(controlLeft).forEach((el) => {
            el.style.left = '610px'
            el.style.bottom = '55px'
          })
        } else {
          const controlLeft = document.getElementsByClassName('control-left')
          Array.from(controlLeft).forEach((el) => {
            el.style.left = '20px'
            el.style.bottom = '55px'
          })
        }
        return
      }

      if (sidebar && isFullMap) {
        this.$nextTick(() => {
          sidebar.scrollTo({ top: 0 })
          this.calculateModalHeight(true)
        })
        if (window.innerWidth < 890) {
          const controlLeft = document.getElementsByClassName('control-left')
          Array.from(controlLeft).forEach((el) => {
            el.style.bottom = '210px'
          })
          const controlRight = document.getElementsByClassName('control-right')
          Array.from(controlRight).forEach((el) => {
            el.style.bottom = '210px'
          })
        }
      } else {
        this.clearSidebarStyle()
      }
    },
    calculateCompHeight(resize = false) {
      if (window.innerWidth >= 890) {
        this.clearSidebarStyle()
        const mapWrapper = document.getElementById('livetrack-map')
        const sidebarWrapper = this.$refs.sidebarWrapper
        if (mapWrapper && sidebarWrapper) {
          mapWrapper.style.height = ''
          sidebarWrapper.style.height = ''
        }
        return
      }

      if (resize) {
        const sidebarEl = this.$refs.sidebarBody
        if (sidebarEl) {
          sidebarEl.scrollTo({ top: 0 })
        }
      }

      this.calculateModalHeight()
      this.calculateMapHeight()
    },
    calculateMapHeight() {
      const mapWrapper = document.getElementById('livetrack-map')

      if (mapWrapper) {
        mapWrapper.style.height = `calc(100vh - ${this.sidebarHeight}px)`
      }
    },
    calculateModalHeight(withAnimation = false) {
      const isFullMap = document.body.classList.contains('mc-full-map')
      const sidebarTime = this.$refs.mobileSidebarEstimate || this.$refs.mobileSidebarActual
      const sidebarToggle = this.$refs.sidebarToggle
      const sidebarHeader = this.$refs.sidebarHeader
      const sidebarStatus = this.$refs.sidebarStatus
      const sidebarFooter = this.$refs.sidebarFooter
      const sidebar = this.$refs.sidebar
      const sidebarWrapper = this.$refs.sidebarWrapper

      let sidebarHeight
      if (
        sidebarTime &&
        sidebarToggle &&
        sidebarHeader &&
        sidebarStatus &&
        sidebarFooter &&
        !isFullMap
      ) {
        sidebarHeight =
          sidebarTime.offsetHeight +
          sidebarToggle.offsetHeight +
          sidebarHeader.offsetHeight +
          sidebarStatus.offsetHeight +
          30 +
          sidebarFooter.offsetHeight
      }

      if (sidebar && sidebarWrapper) {
        if (!withAnimation) {
          sidebar.style.transition = 'none'
        }

        sidebarWrapper.style.height = `calc(100% - ${sidebarFooter.offsetHeight}px)`

        if (sidebarHeight) {
          this.sidebarHeight = sidebarHeight
          sidebar.style.height = `${sidebarHeight}px`
          sidebar.style.top = `calc(100% - ${sidebarHeight}px)`
        }

        if (!withAnimation) {
          sidebar.style.transition = ''
        }
      }
    },
    clearSidebarStyle() {
      if (window.innerWidth < 890) {
        const controlLeft = document.getElementsByClassName('control-left')
        Array.from(controlLeft).forEach((el) => {
          el.style.bottom = 'calc(100% - 90px)'
        })
        const controlRight = document.getElementsByClassName('control-right')
        Array.from(controlRight).forEach((el) => {
          el.style.bottom = 'calc(100% - 90px)'
        })
      }
      const sidebar = this.$refs.sidebar
      if (sidebar) {
        sidebar.style.height = ''
        sidebar.style.top = ''
      }
    },
    handleImageLoad() {
      this.isImageLoading = false
    },
    closeSection() {
      this.$emit('close-section')
    },
  },
}
</script>

<style scoped>
.mc-delivery-track-mobile-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 14px;
  row-gap: 8px;
}

.mc-delivery-track-mobile-info-field {
  grid-column: 1 / -1;
}

.mc-delivery-track-mobile-info-field.is-half {
  grid-column: span 1;
}

.mc-delivery-track-mobile-info-label {
  margin: 0;
  font-size: 12px;
  color: #8e96a3;
}

.mc-delivery-track-mobile-info-value {
  margin: 2px 0 0;
}

.mc-delivery-track-mobile-info-divider {
  grid-column: 1 / -1;
  margin: 2px 0 6px;
}
</style>
